import { SocialLogin } from "features/user/components/SocialLogin";
import { EmailLoginState } from "lib/recoil/email_login";
import { useRouter } from "next/router";
import { useState } from "react";
import { useSetRecoilState } from "recoil";
import * as Repositories from "repositories";
import { PrivacyPolicy } from "shared/components/molecules/PrivacyPolicy";
import { EmailForm } from "shared/components/templates/EmailForm";
import { Loading } from "shared/components/templates/Loading";
import { FormData } from "shared/hooks/useEmailForm";
import { useErrorMessage } from "shared/hooks/useErrorMessage";
import { Colors } from "shared/styles";
import tw, { styled } from "twin.macro";
import { Paths } from "utils/routes";

const styles = {
  title: tw`font-base text-base tracking-[1px]`,
};

const DividerLine = styled.div`
  &:before,
  &:after {
    content: "";
    height: 1px;
    flex-grow: 1;
    background-color: ${Colors.gray["02"]};
    display: block;
  }
  &:before {
    margin-right: 0.5rem;
  }
  &:after {
    margin-left: 0.5rem;
  }
`;

export const SigninUp = () => {
  const [disabled, setDisabled] = useState(false);

  const router = useRouter();
  const setEmail = useSetRecoilState(EmailLoginState);
  const { handleAxiosError } = useErrorMessage();

  const onSubmit = async (data: FormData) => {
    setDisabled(true);
    try {
      const isEmailPresent = await Repositories.UserEmail.show(
        "/me/email",
        data.email
      );
      setEmail(data.email);

      if (isEmailPresent) {
        await router.push(Paths.users.signIn.checkPassword());
      } else {
        await router.push(Paths.users.signIn.createPassword());
      }
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <Loading loading={disabled} />
      <div tw="flex-center flex-col w-full px-8">
        <div tw="text-center my-9">
          <h1 css={styles.title}>外部サービスで登録・ログイン</h1>
          <div tw="font-light text-2xs mt-3">
            鑑定に進むには新規登録もしくはログインが必要です
          </div>
        </div>
        <SocialLogin />
        <DividerLine tw="w-full flex-center text-2xs">もしくは</DividerLine>
        <h2 tw="mt-8" css={styles.title}>
          メールアドレスで登録・ログイン
        </h2>
        <EmailForm tw="mt-5 w-full" onSubmit={onSubmit} buttonLabel="次へ" />
        <PrivacyPolicy
          tw="mt-4"
          prefix="登録すると"
          postfix={
            <>
              に
              <br />
              合意したことになります
            </>
          }
        />
      </div>
    </>
  );
};
